import React, { useCallback } from 'react'
import useQualificationByIds from '@tabeeb/modules/qualifications/hooks/useQualificationsByIds'
import { List, ListItem, ListItemText } from '@mui/material'
import RequiredQualificationsListSkeleton from '@tabeeb/modules/sessionsPage/components/Dialogs/RequiredQualificationsDialog/RequiredQualificationsListSkeleton'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Body1, Tooltip } from '@collaborate-health/uikit'
import { truncateText } from '@tabeeb/shared/utils/text'

interface RequiredQualificationsProps {
  qualificationIds: number[]
  missingQualificationIds: number[]
}

const MAX_QUALIFICATION_NAME_LENGTH = 30

const RequiredQualificationsList: React.FC<RequiredQualificationsProps> = ({
  qualificationIds,
  missingQualificationIds,
}) => {
  const { isLoading, isSuccess, data: qualifications } = useQualificationByIds(qualificationIds)

  const getIcon = useCallback((isMissing: boolean) => {
    if (isMissing) {
      return <ErrorOutlineIcon color='warning' fontSize='inherit' />
    }
    return <CheckCircleOutlineIcon color='success' fontSize='inherit' />
  }, [])

  return (
    <div>
      {isLoading && <RequiredQualificationsListSkeleton qualificationsCount={qualificationIds.length} />}

      {isSuccess && (
        <List component='ul' sx={{ padding: 0, pl: 2 }}>
          {qualifications!.map((qualification) => {
            const isMissing = missingQualificationIds.includes(qualification.Id)
            const icon = getIcon(isMissing)
            const displayName = truncateText(qualification.Name, MAX_QUALIFICATION_NAME_LENGTH)
            const showTooltip = qualification.Name.length > MAX_QUALIFICATION_NAME_LENGTH

            return (
              <ListItem
                key={qualification.Id}
                component='li'
                disableGutters
                sx={{
                  alignItems: 'flex-start',
                  padding: 0,
                  display: 'list-item',
                  listStyleType: 'disc',
                  listStylePosition: 'outside',
                  mt: 0.5,
                }}
              >
                <ListItemText
                  primary={
                    <Tooltip text={showTooltip ? qualification.Name : null}>
                      <Body1 fontSize='16px'>
                        {displayName} {icon}
                      </Body1>
                    </Tooltip>
                  }
                />
              </ListItem>
            )
          })}
        </List>
      )}
    </div>
  )
}

export default RequiredQualificationsList

